import React, { useState, useEffect } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

const NoticePopup = (props) => {
  const [checked, setChecked] = useState(false);
  const { popupClose } = props.childProps;
  const _popupClose = () => {
    console.log(checked);
    popupClose(checked);
  };
  const _checkChange = () => {
    setChecked(!checked);
  };
  const _goNotice = () => {
    window.open('https://www.aniplustv.com/customer/1?idx=77882', '', '');
  };
  return (
    <>
      <div>
        {/* 모일일 이미지 따로 */}
        {isMobile ? (
          <img
            src="/img/notice01_m.png"
            style={{ borderRadius: 10 }}
            onClick={_goNotice}
          />
        ) : (
          <img
            src="/img/notice01.png"
            style={{ borderRadius: 10 }}
            usemap="#image-map"
          />
        )}

        <div style={{ marginTop: 10 }}>
          <input type="checkbox" checked={checked} onChange={_checkChange} />
          <span style={{ color: '#fff', paddingLeft: 10 }}>
            일주일 동안 다시 보지 않기
          </span>
        </div>
      </div>
      <div
        onClick={_popupClose}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: 50,
          color: '#fff',
          backgroundColor: '#ff5d24',
          borderRadius: 10,
          fontSize: 16,
          marginTop: 10,
          cursor: 'pointer',
        }}
      >
        닫기
      </div>
      <map name="image-map">
        <area
          target="_blank"
          alt=""
          title=""
          href="https://www.aniplustv.com/customer/1?idx=77882"
          coords="374,535,538,558"
          shape="rect"
        />
      </map>
    </>
  );
};

export default shopContext(withRouter(NoticePopup));
